// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SwitchToggle_switchWrapper__LKd4M {
  margin-top: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.SwitchToggle_switchRoot__7rAKT {
  width: 52px;
  height: 28px;
  border-radius: 9999px;
  position: relative;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: background 0.3s ease, border 0.3s ease, box-shadow 0.3s ease;
}

.SwitchToggle_switchRoot__7rAKT[data-state="checked"] {
  background: linear-gradient(90deg, #b389ff, #8d6aff);
  border: none;
  box-shadow: 0 0 10px rgba(168, 104, 255, 0.4);
}

.SwitchToggle_switchThumb__gm5E0 {
  width: 24px;
  height: 24px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 1px;
  left: 2px;
  transition: transform 0.25s ease;
  transform: translateX(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.SwitchToggle_switchRoot__7rAKT[data-state="checked"] .SwitchToggle_switchThumb__gm5E0 {
  transform: translateX(24px);
}

.SwitchToggle_toggleLabel__pQV4U {
  font-size: 12px;
  color: #ffffffcc;
  text-align: center;
  line-height: 1.2;
  max-width: 120px;
}

.SwitchToggle_disabled__1a0UO {
  opacity: 0.5;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/SwitchToggle/SwitchToggle.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,0CAA0C;EAC1C,wEAAwE;AAC1E;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":[".switchWrapper {\n  margin-top: 2px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.switchRoot {\n  width: 52px;\n  height: 28px;\n  border-radius: 9999px;\n  position: relative;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  transition: background 0.3s ease, border 0.3s ease, box-shadow 0.3s ease;\n}\n\n.switchRoot[data-state=\"checked\"] {\n  background: linear-gradient(90deg, #b389ff, #8d6aff);\n  border: none;\n  box-shadow: 0 0 10px rgba(168, 104, 255, 0.4);\n}\n\n.switchThumb {\n  width: 24px;\n  height: 24px;\n  background-color: white;\n  border-radius: 50%;\n  position: absolute;\n  top: 1px;\n  left: 2px;\n  transition: transform 0.25s ease;\n  transform: translateX(0);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.switchRoot[data-state=\"checked\"] .switchThumb {\n  transform: translateX(24px);\n}\n\n.toggleLabel {\n  font-size: 12px;\n  color: #ffffffcc;\n  text-align: center;\n  line-height: 1.2;\n  max-width: 120px;\n}\n\n.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switchWrapper": `SwitchToggle_switchWrapper__LKd4M`,
	"switchRoot": `SwitchToggle_switchRoot__7rAKT`,
	"switchThumb": `SwitchToggle_switchThumb__gm5E0`,
	"toggleLabel": `SwitchToggle_toggleLabel__pQV4U`,
	"disabled": `SwitchToggle_disabled__1a0UO`
};
export default ___CSS_LOADER_EXPORT___;
